import { render, staticRenderFns } from "./cardShowAnnounce.vue?vue&type=template&id=9b2e3ad4&scoped=true"
import script from "./cardShowAnnounce.vue?vue&type=script&lang=js"
export * from "./cardShowAnnounce.vue?vue&type=script&lang=js"
import style0 from "./cardShowAnnounce.vue?vue&type=style&index=0&id=9b2e3ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2e3ad4",
  null
  
)

export default component.exports